export const CABLE_LABEL_COLORS = [
  "kraft",
  "white",
  "yellow",
  "red",
  "blue",
  "green",
  "slate",
] as const;

export type CableLabelColor = (typeof CABLE_LABEL_COLORS)[number];

export const DEFAULT_CABLE_LABEL_COLOR: CableLabelColor = "kraft";

type Swatch = {
  bg: string;
  edge: string;
  fg: string;
};

const SWATCHES: Record<CableLabelColor, Swatch> = {
  kraft: {
    bg: "color-mix(in oklab, hsl(40 78% 90%) 78%, var(--color-surface))",
    edge: "hsl(38 30% 62%)",
    fg: "hsl(26 38% 22%)",
  },
  white: {
    bg: "var(--color-surface)",
    edge: "hsl(220 12% 70%)",
    fg: "hsl(220 12% 20%)",
  },
  yellow: {
    bg: "hsl(48 96% 78%)",
    edge: "hsl(38 60% 45%)",
    fg: "hsl(28 80% 18%)",
  },
  red: {
    bg: "hsl(2 78% 88%)",
    edge: "hsl(2 60% 50%)",
    fg: "hsl(2 70% 28%)",
  },
  blue: {
    bg: "hsl(212 78% 90%)",
    edge: "hsl(212 50% 50%)",
    fg: "hsl(212 70% 26%)",
  },
  green: {
    bg: "hsl(142 50% 86%)",
    edge: "hsl(142 38% 40%)",
    fg: "hsl(142 60% 20%)",
  },
  slate: {
    bg: "hsl(220 14% 28%)",
    edge: "hsl(220 14% 50%)",
    fg: "hsl(0 0% 96%)",
  },
};

export function cableLabelSwatch(color: string | undefined): Swatch {
  if (color && color in SWATCHES) {
    return SWATCHES[color as CableLabelColor];
  }
  return SWATCHES[DEFAULT_CABLE_LABEL_COLOR];
}

export function cableLabelSwatchPreview(color: CableLabelColor): {
  bg: string;
  edge: string;
} {
  const s = SWATCHES[color];
  return { bg: s.bg, edge: s.edge };
}
